<template>
    <el-menu
            :default-active="defaultActive"
            :router="true"
    >
        <el-menu-item index="/suppliers">
            <i class="el-icon-menu"></i>
            <span>Manage Suppliers</span>
        </el-menu-item>
        <el-menu-item index="/products">
            <i class="el-icon-s-grid"></i>
            <span>Manage Products</span>
        </el-menu-item>
    </el-menu>
</template>

<script>
    export default {
        data: () => ({
            defaultActive: ""
        }),
        mounted() {
            this.defaultActive = this.$router.currentRoute.path;
        },
        methods: {
            handleSelect(key) {
                this.$router.push(`/${key}`)
            }
        }
    }
</script>

<style scoped lang="scss">
</style>